import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ForgotPasswordFormComponent } from '../../components/forgot-password-form/forgot-password-form.component';
import { LoginLayoutComponent } from '../../components/login-layout/login-layout.component';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [LoginLayoutComponent, ForgotPasswordFormComponent],
  templateUrl: './forgot-password.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [],
})
export class ForgotPasswordComponent {}
